// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { CustomInstrumentListTypeEnum } from '../CustomInstrumentList/CustomInstrumentListTypeEnum';
import { DirectMessageBaseClass } from './DirectMessageBase';
import { Message } from './Message';
export class DirectCustomListMessage extends DirectMessageBaseClass {
    constructor() {
        super(Message.CUSTOM_LIST_MESSAGE);
        this.Id = -1;
        this.Name = '';
        this.Description = '';
        this.ListType = CustomInstrumentListTypeEnum.None;
        this.RawBytes = null; // image
        this.TradableInstrumentId = null; // список инструментов передается в таком же порядке как они были добавлены в БО.
        this.Aliases = null; // 63  - languageAlias LANG = 642 Name = 22 DESCRIPTION = 28
        this.ResponseEnd = false;
    }
}
